import * as React from 'react';
import { Box, Button } from '@chakra-ui/react';
import FileUpload from '../file-upload';

interface IProps {
  id?: string;
  maxFiles: number;
  fileCount: number;
  addLabel?: string;
  fileNames: string[];
  fileStatuses: string[];
  progresses: number[];
  labelText?: string;
  uploadInProgress: boolean;
  onAddAnotherFileClick: (evt: React.MouseEvent) => void;
  onFileUpload: (index: number, fileName: string, file: File) => void;
  onBlur?: (event: React.FormEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FormEvent<HTMLInputElement>) => void;
  onDelete?: (fileName: string) => void;
}

const MultiFileUpload: React.FC<IProps> = (props: IProps) => {
  const {
    id = 'enroly',
    maxFiles = 3,
    fileCount = 1,
    addLabel = 'Add another file',
    fileNames = [],
    fileStatuses = [],
    progresses = [],
    labelText = 'Choose file',
    uploadInProgress,
    onAddAnotherFileClick,
    onFileUpload,
    onBlur,
    onFocus,
    onDelete,
  } = props;

  const generateFileUploads = () => {
    const newFileCount = fileCount > maxFiles ? maxFiles : fileCount;
    const fileUploads = [];
    for (let i = 0, l = newFileCount; i < l; i += 1) {
      fileUploads.push(
        <FileUpload
          id={`${id}-${i}`}
          key={i}
          fileName={fileNames[i]}
          fileStatus={fileStatuses[i]}
          progress={progresses[i]}
          allUploads={fileNames}
          onChange={(fileName: string, file: File) => onFileUpload(i, fileName, file)}
          labelText={fileStatuses[i] === 'OK' ? 'Replace file' : labelText}
          onBlur={onBlur}
          onFocus={onFocus}
          onDelete={onDelete}
        />,
      );
    }
    return fileUploads;
  };
  return (
    <Box id={`${id}-multi-file-upload`} mb={6}>
      {generateFileUploads()}

      {fileCount < maxFiles ? (
        <Button onClick={onAddAnotherFileClick} isDisabled={uploadInProgress} variant="secondary" size="lg">
          {addLabel}
        </Button>
      ) : null}
    </Box>
  );
};

export default MultiFileUpload;
